module.exports = __webpack_public_path__ + "img/icon_index_red.7403eb7d.svg";